import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Input,
  Select,
  SelectItem,
  Textarea,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
  Switch,
  Chip,
} from "@nextui-org/react";
import { IoAddSharp } from "react-icons/io5";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";
import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";
import { useNavigate, useParams } from "react-router-dom";
import UpdateLayout from "../../layouts/UpdateLayout";
import { chipValue } from "../../data/styleData";
import ChatBox from "../../components/ChatBox";
import { imageResizer } from "../../utils";
import { useForm, Controller } from "react-hook-form";
import AcceptOrder from "./AcceptOrder";
import { toast } from "react-toastify";
import axios from "axios";
import AddAssignee from "./AddAssignee";
import {
  getAllSalesRep,
  getAllPartType,
} from "../../store/slices/customerSlice";
import { getWarranty } from "../../store/slices/adminSlice";
import { useDispatch, useSelector } from "react-redux";
import TransactionDetails from "../../components/TransactionDetails";
import Resizer from "react-image-file-resizer";

const UpdateQuote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reps, part_type } = useSelector((state) => state.customer);
  const { warranty } = useSelector((state) => state.admin);
  const [quote, setQuote] = useState([]);
  const [images, setImages] = useState([]);
  const [request, setRequest] = useState([]);
  const [sales, setSales] = useState([]);
  const isDispute = quote?.QuoteStatus?.status === "Dispute";
  // ---- Auth helpers (fresh token on demand) ----
  const authHeaders = () => ({
    headers: { authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });

  // Always refresh if needed, then return headers
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const [warrantys, setWarrantyId] = useState("0");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();
  const { register, handleSubmit, watch, reset, control } = useForm();
  const [imageUpload, setImageUpload] = useState([]);
  let token = localStorage.getItem("accessToken");
  // let headers = {
  //   headers: {
  //     "Content-Type": "multipart/form-data",
  //     authorization: `Bearer ${token}`,
  //   },
  // };
  const authHeader = { headers: { authorization: `Bearer ${token}` } };

  // const uploadImage = async (e) => {
  //   const files = Array.from(e.target.files);

  //   // max total 10 (purani + nayi)
  //   // if (files.length + images.length > 10) {
  //   //   toast.error("Maximum 10 images (old + new) allowed");
  //   //   return;
  //   // }
  //   const editableCount = images.filter((img) => !img.readOnly).length;
  //    if (files.length + editableCount > 10) {
  //      toast.error("Maximum 10 images (old + new) allowed");
  //      return;
  //    }

  //   for (const file of files) {
  //     try {
  //       const resizedFile = await new Promise((resolve) => {
  //         imageResizer(
  //           file,
  //           (blob) => resolve(blob), // <-- blob == File
  //           "JPEG",
  //           800,
  //           800,
  //           80,
  //           0,
  //           "file"
  //         );
  //       });

  //       // backend list
  //       setImageUpload((prev) => [...prev, resizedFile]);
  //       // preview list
  //       const previewURL = URL.createObjectURL(resizedFile);
  //       setImages((prev) => [
  //         ...prev,
  //         { id: `tmp-${Date.now()}`, url: previewURL, isNew: true },
  //       ]);
  //     } catch {
  //       toast.error("Image resize failed");
  //     }
  //   }
  // };

  // const updateData = async (data) => {
  //   try {
  //     const fd = new FormData();
  //     Object.entries(data).forEach(([k, v]) => {
  //       if (k === "shipping_address" || k === "images") return;
  //       if (v === null || v === undefined) return;
  //       fd.append(k, v);
  //     });
  //     imageUpload.forEach((file) => fd.append("images[]", file));

  //     const res = await axios.patch(
  //       `${process.env.REACT_APP_SERVER_URL_V2}/quotes/updatequote/${id}`,
  //       fd,
  //       authHeader
  //     );
  //     toast.success(res.data.message);
  //     getQuoteById(id);
  //   } catch (error) {
  //     let err = error.response.data.message;
  //     toast.error(err);
  //   }
  // };
  const imageResizer = (file, callback) => {
    try {
      Resizer.imageFileResizer(
        file,
        300, // max width
        300, // max height
        "JPEG", // output format
        100, // quality
        0, // rotation
        (uri) => {
          callback(uri); // `uri` is a Blob or File object depending on output type
        },
        "file", // output type
        300,
        300
      );
    } catch (err) {
      console.error("Resizer Error:", err);
      callback(null);
    }
  };

  const uploadImage = async (e) => {
    const files = Array.from(e.target.files);
    const editableCount = images.filter((img) => !img.readOnly).length;

    if (files.length + editableCount > 10) {
      toast.error("Maximum 10 images (old + new) allowed");
      return;
    }

    for (const file of files) {
      try {
        const resizedFile = await new Promise((resolve, reject) => {
          imageResizer(file, (blob) => {
            if (blob instanceof Blob) resolve(blob);
            else reject("Resize failed or invalid blob");
          });
        });

        // Backend: push resized file to upload list
        setImageUpload((prev) => [...prev, resizedFile]);

        // Frontend preview
        const previewURL = URL.createObjectURL(resizedFile);
        setImages((prev) => [
          ...prev,
          { id: `tmp-${Date.now()}`, url: previewURL, isNew: true },
        ]);
      } catch (err) {
        console.error("❌ Image resize error:", err);
        toast.error("Image resize failed");
      }
    }
  };

  const updateData = async (data) => {
    try {
      const fd = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value == null || key === "shipping_address" || key === "images")
          return;
        fd.append(key, value);
      });

      imageUpload.forEach((file, index) => {
        fd.append("images[]", file);
      });
      for (let [key, value] of fd.entries()) {
        console.log(`${key}:`, value);
      }

      const headers = await ensureAuth();
      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL_V2}/quotes/updatequote/${id}`,
        fd,
        headers
      );

      toast.success(res.data.message);
      getQuoteById(id); // refresh
    } catch (error) {
      let err = error?.response?.data?.message || "Failed to update quote";
      toast.error(err);
    }
  };

  function recieptList() {
    let freight_price = parseFloat(watch("freight_price")) || 0;
    let part_price = parseFloat(watch("part_price")) || 0;
    let warranty_price = parseFloat(watch("warranty_price")) || 0;

    const recieptObj = {};
    const quantity = request?.quantity || 1;
    const totalPrice = freight_price + part_price * quantity + warranty_price;
    const applyTax = watch("applyTax");
    const taxRate = 10 / 100;

    if (applyTax) {
      recieptObj.totalTax = Number((totalPrice * taxRate).toFixed(2));
      recieptObj.freightPrice = freight_price;
      recieptObj.partPrice = part_price;
      recieptObj.warrantyPrice = warranty_price;
      recieptObj.totalPrice = Number(
        (totalPrice + (totalPrice * 10) / 100).toFixed(2)
      );
    } else {
      recieptObj.totalTax = Number(
        (totalPrice - (totalPrice * 10) / 11).toFixed(2)
      );
      recieptObj.freightPrice = Number(
        (freight_price / (1 + taxRate)).toFixed(2)
      );
      recieptObj.partPrice = Number((part_price / (1 + taxRate)).toFixed(2));
      recieptObj.warrantyPrice = Number(
        (warranty_price / (1 + taxRate)).toFixed(2)
      );
      recieptObj.totalPrice = Number(totalPrice);
    }

    return recieptObj;
  }

  const bill = recieptList();

  const getQuoteById = useCallback(async () => {
    try {
      let token = localStorage.getItem("accessToken");
      // let headers = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     authorization: `Bearer ${token}`,
      //   },
      // };
      const authHeader = { headers: { authorization: `Bearer ${token}` } };
      const headers = await ensureAuth();
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/quotes/${id}`,
        headers
      );
      // console.log("RESSSSSSSSSSS-------->>>>>>>>", res);
      let data = res?.data?.details;
      setQuote(data?.quote);
      setRequest(data?.quote?.Request);
      // setImages(
      //   (data?.quote_images || []).map((img) => ({
      //     id: img.id,
      //     url: img.url,
      //     isNew: false,
      //   }))
      // );

      // const quoteArr = (data?.quote_images || []).map((img) => ({
      //           id: `q-${img.id}`,
      //           url: img.url,
      //           isNew: false,
      //           readOnly: false,
      //         }));
      //         const reqArr = (data?.request_images || []).map((img) => ({
      //           id: `r-${img.id}`,
      //           url: img.url,
      //           isNew: false,
      //           readOnly: true,
      //         }));
      //         setImages([...quoteArr, ...reqArr]);
      const quoteArr = (data?.quote_images || []).map((img) => ({
        id: `q-${img.id}`,
        url: img.url,
        isNew: false,
      readOnly: false, 
      }));

      setImages(quoteArr);

      if (data?.quote?.status === 4) {
        toast.info("Your quote has been rejected.");
      } else if (data?.quote?.status === 5) {
        toast.info("Your quote is discarded.");
      } else if (data?.quote?.status === 6) {
        toast.info("You have canceled the quote.");
      } else if (data?.quote?.status === 7) {
        toast.info("This quote has been dispute");
      }
    } catch (error) {
      let err = error.response.data.message;
      toast.error(err);
    }
  }, [id]);

  const cancelQuote = () => {
    handleCancel();
    onClose();
  };

  const handleCancel = async () => {
    try {
      const headers = await ensureAuth();
      let res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/quotes/cancel/${id}`,
        "",
        headers
      );
      toast.success("Canceled the quote successfully.");
      setTimeout(() => {
        navigate("/quotes");
      }, 750);
    } catch (error) {
      let err = error?.response?.data?.message;
      // console.log(error);
      toast.error(err);
    }
  };

  // const getCommission = async () => {
  //   let res = null;
  //   try {
  //     let token = localStorage.getItem("accessToken");
  //     let headers = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         authorization: `Bearer ${token}`,
  //       },
  //     };
  //     res = await axios.get(
  //       `${process.env.REACT_APP_SERVER_URL}/admin/commssionrate/${quote?.supplier_id}`,
  //       headers
  //     );
  //   } catch (error) {
  //     console.log("testjadfasa", res);
  //   }
  // };

  useEffect(() => {
    getQuoteById(id);
    dispatch(getAllSalesRep());
    dispatch(getAllPartType());
    dispatch(getWarranty());
  }, [dispatch, id]);

  // useEffect(() => {
  //   if (quote && Object.keys(quote).length > 0) {
  //     getCommission();
  //   }
  // }, [quote]);

  useEffect(() => {
    const resetInputVal = () => {
      if (Object.keys(quote).length > 0) {
        const updateObject = {
          part_price: quote?.part_price,
          shipping_date: quote?.shipping_date?.split("T")[0],
          shipping_address: quote?.shipping_address,
          freight_price: quote?.freight_price,
          warranty: quote?.warranty,
          warranty_option: quote?.warranty_option,
          interchange_number: quote?.interchange_number,
          warranty_price: quote?.warranty_price,
          notes: quote?.notes,
          applyTax: quote?.applyTax,
          sales_repId: quote?.sales_repId,
        };
        if (quote.QuoteOptions.length > 0) updateObject.options = [];
        const optionsArray = quote.QuoteOptions.map((option, index) => {
          return {
            id: option.id,
            part_type: option?.part_type,
            custom_part_type: option?.custom_part_type,
            quantity: option?.quantity,
            part_price: option?.part_price,
            freight_price: option?.freight_price,
            applyTax: option?.applyTax,
            notes: option?.notes,
            warranty: option?.warranty,
            warranty_option: option?.warranty_option,
            warranty_price: option?.warranty_price,
          };
        });
        if (optionsArray.length > 0) updateObject.options = optionsArray;
        // console.log("The updateObject is: ", updateObject);
        reset(updateObject);
        recieptList();
      }
      setWarrantyId(String(quote?.warranty));
      setSales(String(quote?.sales_repId));
    };
    resetInputVal();
  }, [quote, reset]);
  return (
    <div className="overflow-visible">
      <form onSubmit={handleSubmit(updateData)}>
        {quote?.status === 1 ||
        quote?.status === 2 ||
        quote?.status === 4 ||
        quote?.status === 5 ||
        quote?.status === 6 ||
        quote?.status === 7 ? (
          <div>
            <UpdateLayout
              heading={"Quote Details"}
              title={"Update Quote:"}
              width={"80%"}
              images={images}
              status={chipValue[quote.status]}
              requestId={quote?.request_id}
              quoteId={quote?.id}
            >
              <div className="block sm:grid sm:grid-cols-2 gap-2 my-5  ">
                <Select
                  variant="bordered"
                  labelPlacement={"outside"}
                  isDisabled={isDispute}
                  label="&nbsp;"
                  placeholder="Select Sales Rep"
                  selectedKeys={[sales]}
                  className="max-w-xs"
                  {...register("sales_repId", {
                    required: false,
                    valueAsNumber: true,
                  })}
                >
                  <SelectItem key="" onClick={() => sumAssignee()}>
                    <div className="flex gap-2 items-center">
                      <IoAddSharp style={{ fontSize: "0.9rem" }} />
                      <p>Add Sales Reps</p>
                    </div>
                  </SelectItem>
                  {reps.map((rep) => {
                    // console.log("Rep",rep); // This will log the 'rep' object to the console
                    return (
                      <SelectItem
                        key={rep.id}
                        value={rep.SalesRepName}
                        onClick={() => setSales(String(rep.id))}
                      >
                        {rep.SalesRepName}
                      </SelectItem>
                    );
                  })}
                </Select>
                <div className="flex justify-end">
                  <Controller
                    name={`applyTax`}
                    control={control}
                    render={({ field }) => {
                      return (
                        <Switch
                          size="sm"
                          isDisabled={isDispute}
                          isSelected={field.value}
                          onChange={field.onChange}
                        >
                          Price Exclusive Of Tax
                        </Switch>
                      );
                    }}
                  />
                </div>
                <Input
                  type="file"
                  label="Upload Images (Max 5 Image)"
                  isDisabled={isDispute}
                  classNames={{
                    input: inputStyle,
                    inputWrapper: inputWrapperStyle,
                  }}
                  className="mobile-only:mb-5"
                  multiple
                  accept="image/*"
                  labelPlacement={"outside"}
                  placeholder="Choose images"
                  description={""}
                  // {...register("images", { required: false })}
                  onChange={(e) => uploadImage(e)}
                />
                <Input
                  type="date"
                  label="Shipping Date"
                  variant="bordered"
                  isDisabled={isDispute}
                  labelPlacement={"outside"}
                  placeholder="Enter date"
                  description={""}
                  className="w-full text-black mobile-only:mb-5"
                  {...register("shipping_date", { required: false })}
                />

                <Select
                  labelPlacement={"outside"}
                  isDisabled={isDispute}
                  variant="bordered"
                  className="w-full mobile-only:mb-5"
                  label="Warranty Duration"
                  selectedKeys={[String(warrantys)]}
                  placeholder="warranty duration"
                  {...register("warranty", { required: false })}
                >
                  {warranty?.map((item) => {
                    const Value = `${item.duration} ${item.unit}`;
                    return (
                      <SelectItem
                        key={`${item.id}`}
                        value={item.id}
                        onClick={() => setWarrantyId(item.id)}
                      >
                        {Value}
                      </SelectItem>
                    );
                  })}
                </Select>
                <Input
                  type="number"
                  label="Price AU$"
                  placeholder="Price AU$"
                  variant="bordered"
                  isDisabled={isDispute}
                  labelPlacement={"outside"}
                  className="mobile-only:mb-5"
                  onWheel={(e) => e.target.blur()}
                  description={""}
                  {...register("part_price", {
                    required: false,
                    valueAsNumber: true,
                  })}
                />
                <Input
                  type="number"
                  label="Freight Price"
                  placeholder="Freight Price"
                  isDisabled={isDispute}
                  variant="bordered"
                  labelPlacement={"outside"}
                  className="mobile-only:mb-5"
                  description={""}
                  onWheel={(e) => e.target.blur()}
                  {...register("freight_price", {
                    required: false,
                    valueAsNumber: true,
                  })}
                />
                <Input
                  type="text"
                  label="Warranty Option"
                  isDisabled={isDispute}
                  placeholder="warranty option"
                  variant="bordered"
                  labelPlacement={"outside"}
                  className="mobile-only:mb-5"
                  description={""}
                  {...register("warranty_option", { required: false })}
                />
                <Input
                  type="number"
                  label="Warranty Price $"
                  placeholder="Warranty Price $"
                  isDisabled={isDispute}
                  variant="bordered"
                  className="mobile-only:mb-5"
                  labelPlacement={"outside"}
                  onWheel={(e) => e.target.blur()}
                  description={""}
                  {...register("warranty_price", {
                    required: false,
                    valueAsNumber: true,
                  })}
                />
                <Input
                  type="text"
                  label="Interchange Number"
                  placeholder="Interchange Number"
                  variant="bordered"
                  onWheel={(e) => e.target.blur()}
                  isDisabled={isDispute}
                  className="mobile-only:mb-5"
                  labelPlacement={"outside"}
                  description={""}
                  {...register("interchange_number", {
                    required: false,
                  })}
                />

                <Textarea
                  key={"bordered"}
                  variant={"bordered"}
                  maxRows={1}
                  label="Notes"
                  labelPlacement="outside"
                  placeholder="Any message"
                  className="col-span-2 "
                  {...register("notes", { required: false })}
                />
              </div>
            </UpdateLayout>
          </div>
        ) : quote?.status === 3 || quote?.status === 8 ? (
          <AcceptOrder id={id} bill={bill} request={request} />
        ) : (
          ""
        )}

        {quote?.QuoteStatus?.status !== "Order created" &&
          quote?.status !== 3 &&
          quote?.QuoteOptions?.length > 0 && (
            <div className="col-span-2 mt-5">
              <h1 className="font-semibold mt-2">Offer Additional Options: </h1>
              <div className="grid grid-cols-2 gap-4">
                {quote?.QuoteOptions?.map((option, index) =>
                  option?.Part ? (
                    <OptionPartFields
                      option={option}
                      register={register}
                      index={index}
                      control={control}
                      watch={watch}
                      isDispute={isDispute}
                    ></OptionPartFields>
                  ) : (
                    <OptionCustomPartFields
                      option={option}
                      register={register}
                      index={index}
                      control={control}
                      isDispute={isDispute}
                      watch={watch}
                    ></OptionCustomPartFields>
                  )
                )}
                {quote?.QuoteOptions?.length % 2 === 0 && <div></div>}
                <div className="w-full pt-14 ">
                  <TransactionDetails
                    request={quote.Request}
                    bill={
                      bill !== undefined
                        ? { ...bill, partPrice: quote?.part_price }
                        : bill
                    }
                    totalPrice={quote?.total_price}
                    hasWarranty={quote?.has_warranty}
                    applyTax={quote?.applyTax}
                    freightPrice={quote?.freight_price}
                    partPrice={quote?.part_price}
                    WarrantyPrice={quote?.warranty_price}
                  />
                </div>
              </div>
            </div>
          )}

        {quote?.status !== 3 && quote?.QuoteOptions?.length === 0 && (
          <div className="grid grid-cols-2 gap-4">
            <div></div>
            <div>
              <TransactionDetails
                request={request}
                bill={bill}
                totalPrice={quote?.total_price}
                hasWarranty={quote?.has_warranty}
                applyTax={quote?.applyTax}
                freightPrice={quote?.freight_price}
                partPrice={quote?.part_price}
                WarrantyPrice={quote?.warranty_price}
              />
            </div>
          </div>
        )}
        {quote?.status === 1 ||
        quote?.status === 2 ||
        quote?.status === 4 ||
        quote?.status === 5 ||
        quote?.status === 6 ||
        quote?.status === 7 ? (
          <div className="grid grid-cols-2">
            <div></div>

            {quote.status === 1 || quote.status === 2 ? (
              <div className="flex mobile-only:flex-col justify-end gap-5 pb-10">
                <Button
                  type="submit"
                  className=" bg-lightBlue text-white py-1 px-5 mt-6"
                >
                  Update{" "}
                </Button>
                <Button
                  className=" bg-purpleBtn text-white py-1 px-5 mt-6"
                  onClick={() => onOpen()}
                >
                  Cancel
                </Button>
              </div>
            ) : (
              " "
            )}
          </div>
        ) : (
          <div></div>
        )}
      </form>
      <ChatBox quoteId={id} />
      {/* modal for cancel request */}
      <Modal size={"xs"} isOpen={isOpen} onClose={onClose} placement="center">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 justify-center">
                Are you sure?
              </ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-2 gap-2 pb-3">
                  <Button
                    className="border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500 hover:text-white hover:border-none"
                    onClick={cancelQuote}
                  >
                    Yes
                  </Button>
                  <Button
                    className="border-2 border-orange-500 text-orange-500 bg-transparent hover:bg-orange-500 hover:text-white hover:border-none"
                    onPress={onClose}
                  >
                    No
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* modal for add assignee */}
      <AddAssignee addAssignee={addAssignee} closeAssignee={closeAssignee} />
    </div>
  );
};

export default UpdateQuote;

const OptionPartFields = ({
  option,
  index,
  register,
  control,
  watch,
  isDispute,
}) => {
  const { part_type } = useSelector((state) => state.customer);
  const { warranty } = useSelector((state) => state.admin);
  const defaultPartType = String(watch(`options[${index}].part_type`));
  const defaultWarrentyId = String(watch(`options[${index}].warranty`));
  // console.log()
  // console.log("Warrenty is: ", warranty);
  return (
    <>
      <div className="block sm:grid sm:grid-cols-2 gap-3 mt-3 overflow-visible">
        {/* <h1>Option Part Fields</h1> */}
        <div className="col-span-2 flex justify-end">
          <Controller
            name={`options[${index}].applyTax`}
            control={control}
            render={({ field }) => (
              <Switch
                size="sm"
                isSelected={field.value}
                onChange={field.onChange}
              >
                Price Exclusive Of Tax
              </Switch>
            )}
          />
        </div>
        <Select
          labelPlacement={"outside"}
          variant="bordered"
          className="w-full mb-2 bg-white col-span-2 "
          label="Part Type"
          placeholder="Select part type"
          selectedKeys={[defaultPartType]}
          // defaultSelectedKeys={[option?.Part?.name]}
          {...register(`options[${index}].part_type`, {
            required: false,
            valueAsNumber: true,
          })}
        >
          {part_type?.map(
            (item) =>
              item?.id !== 0 && (
                <SelectItem key={item.id} value={item.id}>
                  {item.name}
                </SelectItem>
              )
          )}
        </Select>

        <Input
          type="number"
          label="Quantity"
          isDisabled={isDispute}
          variant="bordered"
          className="mb-2 "
          labelPlacement={"outside"}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          // value={`${option?.quantity}`}
          {...register(`options[${index}].quantity`, {
            valueAsNumber: true,
            required: false,
          })}
        />
        <Input
          type="number"
          label="Price AU$"
          isDisabled={isDispute}
          variant="bordered"
          className="mb-2 "
          labelPlacement={"outside"}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          {...register(`options[${index}].part_price`, {
            required: false,
            valueAsNumber: true,
          })}
        />

        <Input
          type="number"
          isDisabled={isDispute}
          label="Freight Price"
          variant="bordered"
          className="mb-2 "
          labelPlacement={"outside"}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          {...register(`options[${index}].freight_price`, {
            required: false,
            valueAsNumber: true,
          })}
        />
        <Select
          labelPlacement={"outside"}
          variant="bordered"
          isDisabled={isDispute}
          className="w-full mobile-only:mb-5"
          label="Warranty Duration"
          selectedKeys={[defaultWarrentyId]}
          placeholder="warranty duration"
          {...register(`options[${index}].warranty`, {
            valueAsNumber: true,
          })}
        >
          {warranty?.map((item) => {
            const Value = `${item.duration} ${item.unit}`;
            return (
              <SelectItem key={item.id} value={item.id}>
                {Value}
              </SelectItem>
            );
          })}
        </Select>
        {option?.warranty_option && (
          <Input
            type="text"
            label="Warranty Option"
            isDisabled={isDispute}
            variant="bordered"
            className="mb-2 "
            labelPlacement={"outside"}
            placeholder="Warranty option"
            // value={`${option?.warranty_option}`}
            {...register(`options[${index}].warranty_option`, {
              required: false,
            })}
          />
        )}
        {option?.warranty_price && (
          <Input
            type="number"
            label="Warranty Price"
            isDisabled={isDispute}
            variant="bordered"
            className="mb-2 "
            labelPlacement={"outside"}
            placeholder="0"
            onWheel={(e) => e.target.blur()}
            {...register(`options[${index}].warranty_price`, {
              required: false,
              valueAsNumber: true,
            })}
          />
        )}
        <Textarea
          key={"bordered"}
          variant={"bordered"}
          label="Notes"
          isDisabled={isDispute}
          labelPlacement="outside"
          placeholder="Any message"
          maxRows={1}
          className="col-span-2 "
          {...register(`options[${index}].notes`, { required: false })}
        />
      </div>
    </>
  );
};

const OptionCustomPartFields = ({
  option,
  index,
  register,
  control,
  watch,
  isDispute,
}) => {
  const { warranty } = useSelector((state) => state.admin);
  const defaultWarrentyId = String(watch(`options[${index}].warranty`));
  return (
    <>
      <div className="block sm:grid sm:grid-cols-2 gap-3 mt-3">
        {/* <h1>Custom Part Fields</h1> */}
        <div className="col-span-2 flex justify-end">
          <Controller
            name={`options[${index}].applyTax`}
            control={control}
            render={({ field }) => {
              // console.log("The field for custom component is: ", field);
              return (
                <Switch
                  size="sm"
                  isSelected={field.value}
                  onChange={field.onChange}
                >
                  Price Exclusive Of Tax
                </Switch>
              );
            }}
          />
        </div>
        <Input
          type="text"
          label="Custom Part Type"
          variant="bordered"
          isDisabled={isDispute}
          className="mb-2 col-span-2"
          labelPlacement={"outside"}
          placeholder="Custom Part Type"
          // value={`${option?.custom_part_type}`}
          {...register(`options[${index}].custom_part_type`, {
            required: false,
          })}
        />
        <Input
          type="number"
          label="Quantity"
          variant="bordered"
          isDisabled={isDispute}
          className="mb-2"
          labelPlacement={"outside"}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          {...register(`options[${index}].quantity`, {
            required: false,
            valueAsNumber: true,
          })}
        />
        <Input
          type="number"
          label="Price AU$"
          variant="bordered"
          isDisabled={isDispute}
          className="mb-2"
          labelPlacement={"outside"}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          {...register(`options[${index}].custom_part_type`, {
            required: false,
          })}
        />

        <Input
          type="number"
          label="Freight Price"
          variant="bordered"
          className="mb-2 "
          labelPlacement={"outside"}
          isDisabled={isDispute}
          placeholder="0"
          onWheel={(e) => e.target.blur()}
          {...register(`options[${index}].freight_price`, {
            required: false,
            valueAsNumber: true,
          })}
        />
        <Select
          labelPlacement={"outside"}
          variant="bordered"
          isDisabled={isDispute}
          className="w-full mobile-only:mb-5"
          label="Warranty Duration"
          selectedKeys={[defaultWarrentyId]}
          placeholder="warranty duration"
          {...register(`options[${index}].warranty`, {
            valueAsNumber: true,
          })}
        >
          {warranty?.map((item) => {
            const Value = `${item.duration} ${item.unit}`;
            return (
              <SelectItem key={item.id} value={item.id}>
                {Value}
              </SelectItem>
            );
          })}
        </Select>
        {option?.warranty_option && (
          <Input
            type="text"
            label="Warranty Option"
            variant="bordered"
            isDisabled={isDispute}
            className="mb-2 "
            labelPlacement={"outside"}
            placeholder="Warranty option"
            // value={`${option?.warranty_option}`}
            {...register(`options[${index}].warranty_option`, {
              required: false,
            })}
          />
        )}
        {option?.warranty_price && (
          <Input
            type="number"
            label="Warranty Price"
            variant="bordered"
            className="mb-2 "
            isDisabled={isDispute}
            labelPlacement={"outside"}
            placeholder="0"
            onWheel={(e) => e.target.blur()}
            {...register(`options[${index}].warranty_price`, {
              required: false,
              valueAsNumber: true,
            })}
          />
        )}
        <Textarea
          key={"bordered"}
          variant={"bordered"}
          label="Notes"
          maxRows={1}
          labelPlacement="outside"
          placeholder="Any message"
          className="col-span-2 "
          {...register(`options[${index}].notes`, { required: false })}
        />
      </div>
    </>
  );
};
